import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  Avatar,
  FormControl,
  Autocomplete,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress
} from '@mui/material';
import {
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
  Contacts as ContactsIcon,
  Delete as DeleteIcon,
  LocalHospital as HealthIcon,
  Info as InfoIcon,
  LocationOn as LocationIcon,
  NavigateBefore as BackIcon,
  NavigateNext as NextIcon,
  Person as PersonIcon,
  Save as SaveIcon,
  School as SchoolIcon,
  Work as WorkIcon
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import { SwalConfig } from '../../utils/swalConfig';
import dayjs from 'dayjs';

// Import static data structure
import { employeesData } from '../../Data/Kontak/Employee';

const EditEmployee = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [employeeFormData, setEmployeeFormData] = useState({
    // Original API fields
    full_name: '',
    emp_id: '',
    sex: '',
    email: '',
    no_telp: '',
    is_active: 'Active',
    id_department: '',
    id_designation: '',
    id_job_level: '',
    id_bu: '',
    id_office: '',
    grade: '',
    education: '',
    education_major: '',
    collage: '',
    bpjs_tk: '',
    bpjs_kes: '',
    address: '',
    id_subdistrict: '',
    id_city: '',
    id_province: '',
    tax_category: '',
    pph21: '',
    photo: '',
    date_added: dayjs().format('YYYY-MM-DD'),
    date_modified: dayjs().format('YYYY-MM-DD'),
    
    // Additional static fields
    staticData: {
      personalData: {
        employee_id: '',
        employee_code: '',
        gender: '',
        employee_name: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        birth_date: '',
        modified_by: '',
        active_status: 1,
        employment_status: '',
        remarks: '',
        seniority_date: '',
        birth_place: '',
        mother_maiden_name: '',
        marital_status: '',
        marital_date: '',
        religion: '',
        ethnicity: '',
        age: '',
        height_cm: '',
        weight_kg: '',
        phone: '',
        id_number: '',
        id_region: '',
        living_status: '',
        vehicle_type: '',
        vehicle_ownership: '',
        best_achievement: '',
        best_achievement_desc: '',
        worst_achievement: '',
        worst_achievement_desc: '',
        language_active: '',
        language_passive: '',
        education_sponsor: '',
        scholarship: '',
        scholarship_duration: '',
        scholarship_desc: '',
        influence_source: '',
        influence_note: '',
        publication: '',
        highschool_avg_score: '',
        highschool_subject_count: '',
        gpa: '',
        gpa_max: ''
      },
      history: {
        last_job_reason_leave: '',
        last_job_salary: '',
        last_job_benefits: '',
        job_most_liked: '',
        job_least_liked: '',
        hobby: '',
        sport: '',
        sport_desc: '',
        free_time: '',
        reading_hours: '',
        reading_topics: '',
        newspaper: '',
        magazine: ''
      },
      workHistory: [],
      socialActivities: [],
      family: [],
      applicationSkills: {
        apply_reason: '',
        apply_initiator: '',
        apply_initiator_note: '',
        desired_position: '',
        expected_salary: '',
        expected_benefits: '',
        skills: '',
        willing_medical: 0,
        willing_psychology: 0,
        willing_relocate: 0,
        willing_trial: 0,
        willing_transfer: 0,
        willing_rules: 0,
        computer_skill: 0,
        computer_programs: '',
        typing_level: '',
        driving_ability: '',
        vehicle_knowledge: 0
      },
      education: [],
      courses: [],
      generalHealth: {
        willing_original_certificate: 0,
        allow_contact_employer: 0,
        ever_fired: 0,
        decision_advice_source: '',
        decision_advice_note: '',
        personal_advice_source: '',
        personal_advice_note: '',
        reaction_to_criticism: '',
        common_illness: '',
        serious_illness: 0,
        serious_illness_desc: '',
        eye_disease: 0,
        lung_disease: 0,
        ear_disease: 0,
        diabetes: 0,
        hypertension: 0,
        heart_disease: 0,
        last_checkup: '',
        strength: '',
        weakness: ''
      },
      emergency_relations: [],
      former_relations: [],
      guarantors: [],
      workInfo: {
        business_unit: '',
        branch_id: '',
        branch_name: '',
        region: '',
        department: '',
        position: '',
        organization: '',
        composition: '',
        position_group: '',
        grade: '',
        employee_group: '',
        education: '',
        education_group: '',
        university: ''
      },
      address: {
        street: '',
        subdistrict: '',
        rt: '',
        rw: '',
        postal_code: '',
        city: '',
        county: '',
        province: '',
        country: '',
        location_id: ''
      },
      benefit: {
        lspsi: 0,
        lkoperasi: 0,
        lsbsi: 0,
        lspn: 0,
        lbpjs_ketenagakerjaan_date: '',
        lbpjs_ketenagakerjaan_no: '',
        laviva_register_date: '',
        laviva_number: '',
        lbpjs_kesehatan_date: '',
        lbpjs_kesehatan_no: '',
        lbumida_date: '',
        lbumida_no: '',
        lbpjs_pensiun_date: '',
        lbpjs_pensiun_no: '',
        company_insurance_no: ''
      },
      contact: {
        mobile_phone: '',
        alt_mobile_phone: '',
        previous_email: '',
        corporate_email: ''
      },
      tax: {
        tax_category: '',
        tax_id: '',
        payroll_seniority: '',
        salary_scale_date: '',
        year_tax_point_15: '',
        year_tax_point_20: ''
      },
      others: {
        office_type: '',
        pakta_integritas_2025: 0,
        rahasia_perusahaan_2025: 0,
        update_data_karyawan_2025: '',
        penjamin: '',
        update_penjamin_2025: '',
        scan_biodata: 0,
        screening_sdm: 0,
        vehicle_and_facility: 0,
        toll_fee: '',
        distance_km: ''
      }
    }
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [successPopup, setSuccessPopup] = useState(false);
  const [message, setMessage] = useState('');
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [jobLevels, setJobLevels] = useState([]);
  const [businessUnits, setBusinessUnits] = useState([]);
  const [offices, setOffices] = useState([]);
  const [currentPhoto, setCurrentPhoto] = useState('');
  // Quick-add dialogs and inputs (copied/adapted from AddEmployee.jsx)
  const [openAddDepartmentDialog, setOpenAddDepartmentDialog] = useState(false);
  const [openAddDesignationDialog, setOpenAddDesignationDialog] = useState(false);
  const [openAddJoblevelDialog, setOpenAddJoblevelDialog] = useState(false);
  const [openAddBuDialog, setOpenAddBuDialog] = useState(false);
  const [openAddOfficeDialog, setOpenAddOfficeDialog] = useState(false);
  const [newDepartmentCode, setNewDepartmentCode] = useState('');
  const [newDepartmentName, setNewDepartmentName] = useState('');
  const [newDesignationCode, setNewDesignationCode] = useState('');
  const [newDesignationName, setNewDesignationName] = useState('');
  const [newJoblevelCode, setNewJoblevelCode] = useState('');
  const [newJoblevelName, setNewJoblevelName] = useState('');
  const [newBuCode, setNewBuCode] = useState('');
  const [newBuName, setNewBuName] = useState('');
  const [newOfficeCode, setNewOfficeCode] = useState('');
  const [newOfficeName, setNewOfficeName] = useState('');
  const token = localStorage.getItem('token');

  // Quick-add handlers (POST to API and update lists)
  const handleQuickAddDepartment = async () => {
    if (!newDepartmentCode || !newDepartmentName) return;
    try {
      const response = await fetch('https://apidashboard.eurekagroup.id/Department/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          department_code: newDepartmentCode,
          department_name: newDepartmentName,
          is_active: true
        })
      });
      if (!response.ok) throw new Error('Gagal menambah departemen');
      const data = await response.json();
      setDepartments(prev => [...prev, data]);
      setEmployeeFormData(prev => ({ ...prev, id_department: data._id }));
      setNewDepartmentCode('');
      setNewDepartmentName('');
      setOpenAddDepartmentDialog(false);
    } catch (error) {
      console.error(error);
      SwalConfig.error('Gagal', 'Gagal menambah departemen');
    }
  };

  const handleQuickAddDesignation = async () => {
    if (!newDesignationCode || !newDesignationName) return;
    try {
      const response = await fetch('https://apidashboard.eurekagroup.id/designation/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          designation_code: newDesignationCode,
          designation_name: newDesignationName,
          is_active: 1
        })
      });
      if (!response.ok) throw new Error('Gagal menambah posisi');
      const data = await response.json();
      setDesignations(prev => [...prev, data]);
      setEmployeeFormData(prev => ({ ...prev, id_designation: data._id }));
      setNewDesignationCode('');
      setNewDesignationName('');
      setOpenAddDesignationDialog(false);
    } catch (error) {
      console.error(error);
      SwalConfig.error('Gagal', 'Gagal menambah posisi');
    }
  };

  const handleQuickAddJoblevel = async () => {
    if (!newJoblevelCode || !newJoblevelName) return;
    try {
      const response = await fetch('https://apidashboard.eurekagroup.id/joblevel/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          joblevel_code: newJoblevelCode,
          joblevel_name: newJoblevelName,
          id_bu: employeeFormData.id_bu,
          is_active: 1
        })
      });
      if (!response.ok) throw new Error('Gagal menambah level pekerjaan');
      const data = await response.json();
      setJobLevels(prev => [...prev, data]);
      setEmployeeFormData(prev => ({ ...prev, id_job_level: data._id }));
      setNewJoblevelCode('');
      setNewJoblevelName('');
      setOpenAddJoblevelDialog(false);
    } catch (error) {
      console.error(error);
      SwalConfig.error('Gagal', 'Gagal menambah level pekerjaan');
    }
  };

  const handleQuickAddBu = async () => {
    if (!newBuCode || !newBuName) return;
    try {
      const response = await fetch('https://apidashboard.eurekagroup.id/bu/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          bu_code: newBuCode,
          bu_name: newBuName,
          is_active: 1
        })
      });
      if (!response.ok) throw new Error('Gagal menambah unit bisnis');
      const data = await response.json();
      setBusinessUnits(prev => [...prev, data]);
      setEmployeeFormData(prev => ({ ...prev, id_bu: data._id }));
      setNewBuCode('');
      setNewBuName('');
      setOpenAddBuDialog(false);
    } catch (error) {
      console.error(error);
      SwalConfig.error('Gagal', 'Gagal menambah unit bisnis');
    }
  };

  const handleQuickAddOffice = async () => {
    if (!newOfficeCode || !newOfficeName) return;
    try {
      const response = await fetch('https://apidashboard.eurekagroup.id/office/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          office_code: newOfficeCode,
          office_name: newOfficeName,
          is_active: 1
        })
      });
      if (!response.ok) throw new Error('Gagal menambah kantor');
      const data = await response.json();
      setOffices(prev => [...prev, data]);
      setEmployeeFormData(prev => ({ ...prev, id_office: data._id }));
      setNewOfficeCode('');
      setNewOfficeName('');
      setOpenAddOfficeDialog(false);
    } catch (error) {
      console.error(error);
      SwalConfig.error('Gagal', 'Gagal menambah kantor');
    }
  };

  const steps = [
    'Data Pribadi',
    'Informasi Pekerjaan', 
    'Pendidikan & Lokasi',
    'Informasi Tambahan',
    'Data Kandidat (Riwayat)',
    'Data Kandidat (Keluarga)',
    'Data Kandidat (Kemampuan)',
    'Data Kandidat (Kesehatan)',
    'Pendidikan Formal',
    'Riwayat Pekerjaan',
    'Kursus & Pelatihan',
    'Relasi & Penjamin'
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setFetching(true);
        
        // Fetch dropdown data
        const [departmentResponse, designationResponse, jobLevelResponse, businessUnitResponse, officeResponse] = await Promise.all([
          fetch('https://apidashboard.eurekagroup.id/department'),
          fetch('https://apidashboard.eurekagroup.id/designation'),
          fetch('https://apidashboard.eurekagroup.id/joblevel'),
          fetch('https://apidashboard.eurekagroup.id/bu'),
          fetch('https://apidashboard.eurekagroup.id/office')
        ]);

        const [departments, designations, jobLevels, businessUnits, offices] = await Promise.all([
          departmentResponse.json(),
          designationResponse.json(),
          jobLevelResponse.json(),
          businessUnitResponse.json(),
          officeResponse.json()
        ]);

      setDepartments(departments);
      setDesignations(designations);
      setJobLevels(jobLevels);
      setBusinessUnits(businessUnits);
      setOffices(offices);

        // Fetch employee data
        await fetchEmployeeData();
      } catch (error) {
        console.error('Error fetching data:', error);
        SwalConfig.error('Error', 'Gagal memuat data: ' + error.message);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [id]);

  const fetchEmployeeData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://apidashboard.eurekagroup.id/employee/get/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': 'true'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response status:', response.status);
        console.error('Response body:', errorText);
        throw new Error(`Failed to fetch employee data: ${response.status}`);
      }

      const employeeData = await response.json();
      console.log('Fetched employee data:', employeeData);

      // Populate form with fetched data
    setEmployeeFormData({
        // Basic employee info
        full_name: employeeData.full_name || '',
        emp_id: employeeData.emp_id || employeeData.employee_id || '',
        sex: employeeData.sex || employeeData.gender || '',
        email: employeeData.email || '',
        no_telp: employeeData.mobile_phone || '',
        is_active: employeeData.is_active || 'Active',
        id_department: employeeData.id_department?._id || '',
        id_designation: employeeData.id_designation?._id || '',
        id_job_level: employeeData.id_job_level?._id || '',
        id_bu: employeeData.id_bu?._id || '',
        id_office: employeeData.id_office?._id || '',
        grade: employeeData.grade || '',
        education: employeeData.education || '',
        education_major: employeeData.education_major || '',
        collage: employeeData.collage || '',
        bpjs_tk: employeeData.bpjs_tk || '',
        bpjs_kes: employeeData.bpjs_kes || '',
        address: employeeData.address || '',
        id_subdistrict: employeeData.id_subdistrict || '',
        id_city: employeeData.id_city || '',
        id_province: employeeData.id_province || '',
        tax_category: employeeData.tax_category || '',
        pph21: employeeData.pph21 || '',
        photo: employeeData.photo || '',
        hire_date: employeeData.hire_date ? dayjs(employeeData.hire_date).format('YYYY-MM-DD') : '',
        employee_status: employeeData.employee_status || '',
        date_added: employeeData.date_added ? dayjs(employeeData.date_added).format('YYYY-MM-DD') : '',
        date_modified: dayjs().format('YYYY-MM-DD'),
        birth_date: employeeData.birth_date ? dayjs(employeeData.birth_date).format('YYYY-MM-DD') : '',

        // Static data
      staticData: {
          personalData: {
            employee_id: employeeData.emp_id || employeeData.employee_id || '',
            employee_code: employeeData.emp_id || employeeData.employee_id || '',
            gender: employeeData.sex || employeeData.gender || '',
            employee_name: employeeData.full_name || '',
            first_name: employeeData.first_name || '',
            middle_name: employeeData.middle_name || '',
            last_name: employeeData.last_name || '',
            birth_date: employeeData.birth_date ? dayjs(employeeData.birth_date).format('YYYY-MM-DD') : '',
            modified_by: '',
            active_status: employeeData.is_active === 'Active' ? 1 : 0,
            employment_status: employeeData.employment_status || '',
            remarks: '',
            seniority_date: employeeData.seniority_date ? dayjs(employeeData.seniority_date).format('YYYY-MM-DD') : '',
            birth_place: employeeData.birth_place || '',
            mother_maiden_name: employeeData.mother_maiden_name || '',
            marital_status: employeeData.marital_status || '',
            marital_date: employeeData.marital_date ? dayjs(employeeData.marital_date).format('YYYY-MM-DD') : '',
            religion: employeeData.religion || '',
            ethnicity: employeeData.ethnicity || '',
            age: employeeData.age || '',
            height_cm: employeeData.height_cm || '',
            weight_kg: employeeData.weight_kg || '',
            phone: employeeData.mobile_phone || '',
            id_number: '',
            id_region: '',
            living_status: '',
            vehicle_type: '',
            vehicle_ownership: '',
            best_achievement: employeeData.best_achievement || '',
            best_achievement_desc: '',
            worst_achievement: '',
            worst_achievement_desc: '',
            language_active: '',
            language_passive: '',
            education_sponsor: '',
            scholarship: '',
            scholarship_duration: '',
            scholarship_desc: '',
            influence_source: '',
            influence_note: '',
            publication: '',
            highschool_avg_score: '',
            highschool_subject_count: '',
            gpa: '',
            gpa_max: ''
          },
          history: {
            last_job_reason_leave: employeeData.last_job_reason_leave || '',
            last_job_salary: employeeData.last_job_salary || '',
            last_job_benefits: '',
            job_most_liked: '',
            job_least_liked: '',
            hobby: employeeData.hobby || '',
            sport: employeeData.sport || '',
            sport_desc: '',
            free_time: '',
            reading_hours: '',
            reading_topics: '',
            newspaper: '',
            magazine: ''
          },
          workHistory: employeeData.work_history_data || [],
          socialActivities: employeeData.social_activities_data || [],
          family: employeeData.family_data || [],
          applicationSkills: {
            apply_reason: employeeData.apply_reason || '',
            apply_initiator: '',
            apply_initiator_note: '',
            desired_position: employeeData.desired_position || '',
            expected_salary: employeeData.expected_salary || '',
            expected_benefits: '',
            skills: employeeData.skills || '',
            willing_medical: 0,
            willing_psychology: 0,
            willing_relocate: 0,
            willing_trial: 0,
            willing_transfer: 0,
            willing_rules: 0,
            computer_skill: 0,
            computer_programs: employeeData.computer_programs || '',
            typing_level: '',
            driving_ability: employeeData.driving_ability || '',
            vehicle_knowledge: 0
          },
          education: employeeData.education_data || [],
          courses: employeeData.courses_data || [],
          generalHealth: {
            willing_original_certificate: 0,
            allow_contact_employer: 0,
            ever_fired: 0,
            decision_advice_source: '',
            decision_advice_note: '',
            personal_advice_source: '',
            personal_advice_note: '',
            reaction_to_criticism: employeeData.reaction_to_criticism || '',
            common_illness: employeeData.common_illness || '',
            serious_illness: 0,
            serious_illness_desc: '',
            eye_disease: 0,
            lung_disease: 0,
            ear_disease: 0,
            diabetes: 0,
            hypertension: 0,
            heart_disease: 0,
            last_checkup: employeeData.last_checkup ? dayjs(employeeData.last_checkup).format('YYYY-MM-DD') : '',
            strength: employeeData.strength || '',
            weakness: employeeData.weakness || ''
          },
          emergency_relations: employeeData.emergency_relations_data || [],
          former_relations: employeeData.former_relations_data || [],
          guarantors: employeeData.guarantors_data || [],
          workInfo: {
            business_unit: employeeData.id_bu?.bu_name || '',
            branch_id: '',
            branch_name: '',
            region: '',
            department: employeeData.id_department?.department_name || '',
            position: employeeData.id_designation?.designation_name || '',
            organization: '',
            composition: '',
            position_group: '',
            grade: employeeData.grade || '',
            employee_group: '',
            education: employeeData.education || '',
            education_group: '',
            university: employeeData.collage || ''
          },
          address: {
            street: employeeData.address || '',
            subdistrict: employeeData.id_subdistrict || '',
            rt: '',
            rw: '',
            postal_code: '',
            city: employeeData.id_city || '',
            county: '',
            province: employeeData.id_province || '',
            country: '',
            location_id: ''
          },
          benefit: {
            lspsi: 0,
            lkoperasi: 0,
            lsbsi: 0,
            lspn: 0,
            lbpjs_ketenagakerjaan_date: '',
            lbpjs_ketenagakerjaan_no: employeeData.bpjs_tk || '',
            laviva_register_date: '',
            laviva_number: '',
            lbpjs_kesehatan_date: '',
            lbpjs_kesehatan_no: employeeData.bpjs_kes || '',
            lbumida_date: '',
            lbumida_no: '',
            lbpjs_pensiun_date: '',
            lbpjs_pensiun_no: '',
            company_insurance_no: ''
          },
          contact: {
            mobile_phone: employeeData.mobile_phone || '',
            alt_mobile_phone: '',
            previous_email: '',
            corporate_email: employeeData.email || ''
          },
          tax: {
            tax_category: employeeData.tax_category || '',
            tax_id: employeeData.tax_id || '',
            payroll_seniority: employeeData.payroll_seniority || '',
            salary_scale_date: '',
            year_tax_point_15: '',
            year_tax_point_20: ''
          },
          others: {
            office_type: '',
            pakta_integritas_2025: 0,
            rahasia_perusahaan_2025: 0,
            update_data_karyawan_2025: '',
            penjamin: '',
            update_penjamin_2025: '',
            scan_biodata: 0,
            screening_sdm: 0,
            vehicle_and_facility: 0,
            toll_fee: '',
            distance_km: ''
          }
        }
      });

      // Set current photo for display
      if (employeeData.photo) {
        setCurrentPhoto(employeeData.photo);
      }

    } catch (error) {
      console.error('Error fetching employee data:', error);
      SwalConfig.error('Error', 'Gagal memuat data karyawan: ' + error.message);
    }
  };

  const handleCancel = () => {
    navigate('/kontak/employee');
  };

  const handleNext = () => {
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => {
    setActiveStep(prev => prev - 1);
  };

  const handleSaveEmployee = async () => {
    const apiUrl = 'https://apidashboard.eurekagroup.id/employee/edit';
  
    // Validation for required fields
    const missingFields = [];
    if (!employeeFormData.full_name) missingFields.push('Nama Lengkap');
    if (!employeeFormData.email) missingFields.push('Email');
    if (!employeeFormData.no_telp) missingFields.push('Nomor Telepon');
    if (!employeeFormData.sex) missingFields.push('Jenis Kelamin');
  
    if (missingFields.length > 0) {
      SwalConfig.validationWarning(missingFields);
      return;
    }
  
    // Prepare the FormData object
    const currentDate = new Date().toISOString().split('T')[0]; // Format YYYY-MM-DD
    const formData = new FormData();
  
    // Add ID for update
    formData.append('id', id);
  
    // === BASIC EMPLOYEE INFO (FORM FIELDS LANGSUNG) ===
    formData.append('full_name', employeeFormData.full_name || '');
    formData.append('emp_id', employeeFormData.emp_id || '');
    formData.append('sex', employeeFormData.sex || '');
    formData.append('email', employeeFormData.email || '');
    formData.append('no_telp', employeeFormData.no_telp || '');
    formData.append('is_active', employeeFormData.is_active || 'Active');
    formData.append('id_department', employeeFormData.id_department || '');
    formData.append('id_designation', employeeFormData.id_designation || '');
    formData.append('id_job_level', employeeFormData.id_job_level || '');
    formData.append('id_bu', employeeFormData.id_bu || '');
    formData.append('id_office', employeeFormData.id_office || '');
    formData.append('grade', employeeFormData.grade || '');
    formData.append('education', employeeFormData.education || '');
    formData.append('education_major', employeeFormData.education_major || '');
    formData.append('collage', employeeFormData.collage || '');
    formData.append('bpjs_tk', employeeFormData.bpjs_tk || '');
    formData.append('bpjs_kes', employeeFormData.bpjs_kes || '');
    formData.append('address', employeeFormData.address || '');
    formData.append('id_subdistrict', employeeFormData.id_subdistrict || '');
    formData.append('id_city', employeeFormData.id_city || '');
    formData.append('id_province', employeeFormData.id_province || '');
    formData.append('tax_category', employeeFormData.tax_category || '');
    formData.append('pph21', employeeFormData.pph21 || '');
    formData.append('birth_date', employeeFormData.birth_date || '');
    formData.append('date_added', employeeFormData.date_added);
    formData.append('date_modified', currentDate);
    
    // Only append photo if it's a new file (not the existing photo)
    if (employeeFormData.photo && employeeFormData.photo instanceof File) {
      formData.append('photo', employeeFormData.photo);
    }
  
    // === CANDIDATE PERSONAL DATA (DARI FORM) ===
    // Field yang ADA DI FORM - renderPersonalDataForm (Step 0)
    formData.append('first_name', employeeFormData.staticData?.personalData?.first_name || '');
    formData.append('middle_name', employeeFormData.staticData?.personalData?.middle_name || '');
    formData.append('last_name', employeeFormData.staticData?.personalData?.last_name || '');
    
    // Field yang ADA DI FORM - renderCandidateHistoryForm (Step 4)
    formData.append('birth_place', employeeFormData.staticData?.personalData?.birth_place || '');
    formData.append('religion', employeeFormData.staticData?.personalData?.religion || '');
    formData.append('ethnicity', employeeFormData.staticData?.personalData?.ethnicity || '');
    formData.append('age', employeeFormData.staticData?.personalData?.age || '');
    formData.append('height_cm', employeeFormData.staticData?.personalData?.height_cm || '');
    formData.append('weight_kg', employeeFormData.staticData?.personalData?.weight_kg || '');
    
    // Field yang ADA DI FORM - renderCandidateFamilyForm (Step 5)
    formData.append('marital_status', employeeFormData.staticData?.personalData?.marital_status || '');
    formData.append('marital_date', employeeFormData.staticData?.personalData?.marital_date || '');
    formData.append('mother_maiden_name', employeeFormData.staticData?.personalData?.mother_maiden_name || '');
    formData.append('living_status', employeeFormData.staticData?.personalData?.living_status || '');
    
    // Field yang ADA DI FORM - renderCandidateHealthForm (Step 7)
    formData.append('best_achievement', employeeFormData.staticData?.personalData?.best_achievement || '');
  
    // === CANDIDATE HISTORY DATA (DARI FORM STEP 4 - renderCandidateHistoryForm) ===
    // Field yang ADA DI FORM
    formData.append('last_job_reason_leave', employeeFormData.staticData?.history?.last_job_reason_leave || '');
    formData.append('last_job_salary', employeeFormData.staticData?.history?.last_job_salary || '');
    formData.append('hobby', employeeFormData.staticData?.history?.hobby || '');
    formData.append('sport', employeeFormData.staticData?.history?.sport || '');

    // === CANDIDATE SKILLS (DARI FORM STEP 6 - renderCandidateSkillsForm) ===
    // Field yang ADA DI FORM
    formData.append('apply_reason', employeeFormData.staticData?.applicationSkills?.apply_reason || '');
    formData.append('desired_position', employeeFormData.staticData?.applicationSkills?.desired_position || '');
    formData.append('expected_salary', employeeFormData.staticData?.applicationSkills?.expected_salary || '');
    formData.append('skills', employeeFormData.staticData?.applicationSkills?.skills || '');
    formData.append('computer_programs', employeeFormData.staticData?.applicationSkills?.computer_programs || '');
    formData.append('driving_ability', employeeFormData.staticData?.applicationSkills?.driving_ability || '');
  
    // === CANDIDATE HEALTH (DARI FORM STEP 7 - renderCandidateHealthForm) ===
    // Field yang ADA DI FORM
    formData.append('common_illness', employeeFormData.staticData?.generalHealth?.common_illness || '');
    formData.append('last_checkup', employeeFormData.staticData?.generalHealth?.last_checkup || '');
    formData.append('strength', employeeFormData.staticData?.generalHealth?.strength || '');
    formData.append('weakness', employeeFormData.staticData?.generalHealth?.weakness || '');
    formData.append('reaction_to_criticism', employeeFormData.staticData?.generalHealth?.reaction_to_criticism || '');
  
    // === MULTIPLE DATA ARRAYS ===
    // Family Data
    if (employeeFormData.staticData?.family?.length > 0) {
      employeeFormData.staticData.family.forEach((member, index) => {
        formData.append(`family_data[${index}][type]`, member.type || '');
        formData.append(`family_data[${index}][name]`, member.name || '');
        formData.append(`family_data[${index}][gender]`, member.gender || '');
        formData.append(`family_data[${index}][age]`, member.age || '');
        formData.append(`family_data[${index}][education]`, member.education || '');
        formData.append(`family_data[${index}][position]`, member.position || '');
        formData.append(`family_data[${index}][job]`, member.job || '');
        formData.append(`family_data[${index}][company]`, member.company || '');
        formData.append(`family_data[${index}][notes]`, member.notes || '');
      });
    }
  
    // Education Data
    if (employeeFormData.staticData?.education?.length > 0) {
      employeeFormData.staticData.education.forEach((edu, index) => {
        formData.append(`education_data[${index}][level]`, edu.level || '');
        formData.append(`education_data[${index}][school_name]`, edu.school_name || '');
        formData.append(`education_data[${index}][location]`, edu.location || '');
        formData.append(`education_data[${index}][graduation_year]`, edu.graduation_year || '');
        formData.append(`education_data[${index}][gpa]`, edu.gpa || '');
        formData.append(`education_data[${index}][major]`, edu.major || '');
      });
    }
  
    // Work History Data
    if (employeeFormData.staticData?.workHistory?.length > 0) {
      employeeFormData.staticData.workHistory.forEach((work, index) => {
        formData.append(`work_history_data[${index}][entry_date]`, work.entry_date || '');
        formData.append(`work_history_data[${index}][exit_date]`, work.exit_date || '');
        formData.append(`work_history_data[${index}][position]`, work.position || '');
        formData.append(`work_history_data[${index}][company]`, work.company || '');
        formData.append(`work_history_data[${index}][address_phone]`, work.address_phone || '');
        formData.append(`work_history_data[${index}][notes]`, work.notes || '');
      });
    }
  
    // Courses Data
    if (employeeFormData.staticData?.courses?.length > 0) {
      employeeFormData.staticData.courses.forEach((course, index) => {
        formData.append(`courses_data[${index}][instructor_institution]`, course.instructor_institution || '');
        formData.append(`courses_data[${index}][location]`, course.location || '');
        formData.append(`courses_data[${index}][duration]`, course.duration || '');
        formData.append(`courses_data[${index}][funded_by]`, course.funded_by || '');
        formData.append(`courses_data[${index}][notes]`, course.notes || '');
      });
    }
  
    // Social Activities Data
    if (employeeFormData.staticData?.socialActivities?.length > 0) {
      employeeFormData.staticData.socialActivities.forEach((activity, index) => {
        formData.append(`social_activities_data[${index}][year]`, activity.year || '');
        formData.append(`social_activities_data[${index}][activity_type]`, activity.activity_type || '');
        formData.append(`social_activities_data[${index}][position]`, activity.position || '');
        formData.append(`social_activities_data[${index}][organization]`, activity.organization || '');
        formData.append(`social_activities_data[${index}][notes]`, activity.notes || '');
      });
    }
  
    // Emergency Relations Data
    if (employeeFormData.staticData?.emergency_relations?.length > 0) {
      employeeFormData.staticData.emergency_relations.forEach((relation, index) => {
        formData.append(`emergency_relations_data[${index}][name]`, relation.name || '');
        formData.append(`emergency_relations_data[${index}][age]`, relation.age || '');
        formData.append(`emergency_relations_data[${index}][address]`, relation.address || '');
        formData.append(`emergency_relations_data[${index}][phone]`, relation.phone || '');
        formData.append(`emergency_relations_data[${index}][relationship]`, relation.relationship || '');
        formData.append(`emergency_relations_data[${index}][notes]`, relation.notes || '');
      });
    }
  
    // Former Relations Data
    if (employeeFormData.staticData?.former_relations?.length > 0) {
      employeeFormData.staticData.former_relations.forEach((relation, index) => {
        formData.append(`former_relations_data[${index}][name]`, relation.name || '');
        formData.append(`former_relations_data[${index}][age]`, relation.age || '');
        formData.append(`former_relations_data[${index}][address]`, relation.address || '');
        formData.append(`former_relations_data[${index}][phone]`, relation.phone || '');
        formData.append(`former_relations_data[${index}][relationship]`, relation.relationship || '');
        formData.append(`former_relations_data[${index}][notes]`, relation.notes || '');
      });
    }
  
    // Guarantors Data
    if (employeeFormData.staticData?.guarantors?.length > 0) {
      employeeFormData.staticData.guarantors.forEach((guarantor, index) => {
        formData.append(`guarantors_data[${index}][name]`, guarantor.name || '');
        formData.append(`guarantors_data[${index}][age]`, guarantor.age || '');
        formData.append(`guarantors_data[${index}][address]`, guarantor.address || '');
        formData.append(`guarantors_data[${index}][phone]`, guarantor.phone || '');
        formData.append(`guarantors_data[${index}][relationship]`, guarantor.relationship || '');
        formData.append(`guarantors_data[${index}][notes]`, guarantor.notes || '');
      });
    }
  
    // === META INFO ===
    formData.append('data_source', 'frontend_form');
    formData.append('form_version', '1.0');
    formData.append('created_at', new Date().toISOString());
    formData.append('has_multiple_data[family]', (employeeFormData.staticData?.family?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[education]', (employeeFormData.staticData?.education?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[work_history]', (employeeFormData.staticData?.workHistory?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[courses]', (employeeFormData.staticData?.courses?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[social_activities]', (employeeFormData.staticData?.socialActivities?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[emergency_relations]', (employeeFormData.staticData?.emergency_relations?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[former_relations]', (employeeFormData.staticData?.former_relations?.length || 0) > 0 ? 'true' : 'false');
    formData.append('has_multiple_data[guarantors]', (employeeFormData.staticData?.guarantors?.length || 0) > 0 ? 'true' : 'false');
    formData.append('total_records[family_count]', employeeFormData.staticData?.family?.length || 0);
    formData.append('total_records[education_count]', employeeFormData.staticData?.education?.length || 0);
    formData.append('total_records[work_history_count]', employeeFormData.staticData?.workHistory?.length || 0);
    formData.append('total_records[courses_count]', employeeFormData.staticData?.courses?.length || 0);
    formData.append('total_records[social_activities_count]', employeeFormData.staticData?.socialActivities?.length || 0);
    formData.append('total_records[emergency_relations_count]', employeeFormData.staticData?.emergency_relations?.length || 0);
    formData.append('total_records[former_relations_count]', employeeFormData.staticData?.former_relations?.length || 0);
    formData.append('total_records[guarantors_count]', employeeFormData.staticData?.guarantors?.length || 0);
  
    // Debug logging
    console.log('=== FORM SUBMISSION DEBUG ===');
    console.log('Employee Form Data:', employeeFormData);
    console.log('Form data being sent:', Array.from(formData.entries()));
    console.log('API URL:', apiUrl);
    
    // Log specific sections for debugging
    console.log('Basic Info:', {
      full_name: employeeFormData.full_name,
      emp_id: employeeFormData.emp_id,
      email: employeeFormData.email,
      sex: employeeFormData.sex
    });
    
    console.log('Static Data:', employeeFormData.staticData);
    console.log('Family Data Count:', employeeFormData.staticData?.family?.length || 0);
    console.log('Education Data Count:', employeeFormData.staticData?.education?.length || 0);
    
    // Create a readable payload object for debugging
    const payloadObject = {};
    for (let [key, value] of formData.entries()) {
      payloadObject[key] = value;
    }
    console.log('Formatted Payload Object:', payloadObject);
  
    const token = localStorage.getItem('token'); // Get token from localStorage
  
    try {
      setLoading(true); // Set loading to true when submitting
      const response = await fetch(apiUrl, {
        method: 'PUT',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`, // Add Authorization header
        },
      });
  
      const result = await response.json();
      console.log('=== BACKEND RESPONSE ===');
      console.log('Response status:', response.status);
      console.log('Response headers:', Object.fromEntries(response.headers.entries()));
      console.log('API response:', result);
      
      // Log if there are any validation errors
      if (result.errors) {
        console.log('Validation errors:', result.errors);
      }
      if (result.message) {
        console.log('Response message:', result.message);
      }
  
      // Adjusted success condition
      if (response.ok) {
      SwalConfig.success(
          'Berhasil Diupdate!',
          `Karyawan ${employeeFormData.full_name} berhasil diupdate!`,
        2500
      ).then(() => {
        navigate('/kontak/employee');
      });
      } else {
        // Handle errors based on the response status
        SwalConfig.error(
          'Gagal Mengupdate!',
          `Gagal mengupdate karyawan: ${result.message || 'Kesalahan tidak diketahui'}`
        );
      }
    } catch (error) {
      console.error('Error updating employee data:', error);
      SwalConfig.error(
        'Error',
        'Error updating employee data: ' + error.message
      );
    } finally {
      setLoading(false); // Reset loading state after completion
    }
  };

  // All the form rendering functions from AddEmployee.jsx
  const renderPersonalDataForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'primary.main' }}>
                <PersonIcon />
              </Avatar>
            }
        title="Data Pribadi"
            titleTypographyProps={{ fontWeight: 600 }}
          />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nama Lengkap"
              value={employeeFormData.full_name}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, full_name: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="ID Karyawan"
              value={employeeFormData.emp_id}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, emp_id: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
            fullWidth
              label="Nama Depan"
              value={employeeFormData.staticData.personalData.first_name}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    first_name: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nama Tengah"
              value={employeeFormData.staticData.personalData.middle_name}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    middle_name: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nama Belakang"
              value={employeeFormData.staticData.personalData.last_name}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    last_name: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth required>
              <InputLabel>Jenis Kelamin</InputLabel>
          <Select
            value={employeeFormData.sex}
            onChange={(e) => setEmployeeFormData({ ...employeeFormData, sex: e.target.value })}
              >
                <MenuItem value="Male">Laki-laki</MenuItem>
                <MenuItem value="Female">Perempuan</MenuItem>
          </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Status Aktif</InputLabel>
              <Select
                value={employeeFormData.is_active}
                onChange={(e) => setEmployeeFormData({ ...employeeFormData, is_active: e.target.value })}
              >
                <MenuItem value="Active">Aktif</MenuItem>
                <MenuItem value="Inactive">Tidak Aktif</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={employeeFormData.email}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, email: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nomor Telepon"
              value={employeeFormData.no_telp}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, no_telp: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                Foto Karyawan
              </Typography>
              {currentPhoto && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Foto saat ini: {currentPhoto}
                  </Typography>
                </Box>
              )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, photo: e.target.files[0] })}
              style={{
                padding: '16px 8px 8px 8px', 
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  width: '100%'
              }}
            />
              <Typography variant="caption" color="text.secondary">
                Kosongkan jika tidak ingin mengubah foto
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Include all other form rendering functions from AddEmployee.jsx here...
  // (renderWorkInformationForm, renderEducationLocationForm, etc.)
  // For brevity, I'll include the key ones and you can copy the rest

  const renderWorkInformationForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'success.main' }}>
            <WorkIcon />
          </Avatar>
        }
        title="Informasi Pekerjaan"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Autocomplete
                fullWidth
                options={departments}
                getOptionLabel={(option) => option?.department_name || ''}
                value={departments.find(d => d._id === employeeFormData.id_department) || null}
                onChange={(_, newValue) => {
                  if (newValue?.isAddNew) {
                    setOpenAddDepartmentDialog(true);
                  } else {
                    setEmployeeFormData({ ...employeeFormData, id_department: newValue?._id || '' });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter(option => option.department_name?.toLowerCase().includes(params.inputValue.toLowerCase()));
                  if (params.inputValue !== '' && filtered.length === 0) {
                    filtered.push({ isAddNew: true, department_name: `+ Tambah "${params.inputValue}"`, _id: 'add-new' });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Departemen" placeholder="Cari departemen" />
                )}
              />
              <IconButton color="primary" onClick={() => setOpenAddDepartmentDialog(true)} size="large">
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Autocomplete
                fullWidth
                options={designations}
                getOptionLabel={(option) => option?.designation_name || ''}
                value={designations.find(d => d._id === employeeFormData.id_designation) || null}
                onChange={(_, newValue) => {
                  if (newValue?.isAddNew) {
                    setOpenAddDesignationDialog(true);
                  } else {
                    setEmployeeFormData({ ...employeeFormData, id_designation: newValue?._id || '' });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter(option => option.designation_name?.toLowerCase().includes(params.inputValue.toLowerCase()));
                  if (params.inputValue !== '' && filtered.length === 0) {
                    filtered.push({ isAddNew: true, designation_name: `+ Tambah "${params.inputValue}"`, _id: 'add-new' });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Posisi" placeholder="Cari posisi" />
                )}
              />
              <IconButton color="primary" onClick={() => setOpenAddDesignationDialog(true)} size="large">
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Autocomplete
                fullWidth
                options={jobLevels}
                getOptionLabel={(option) => option?.joblevel_name || ''}
                value={jobLevels.find(j => j._id === employeeFormData.id_job_level) || null}
                onChange={(_, newValue) => {
                  if (newValue?.isAddNew) {
                    setOpenAddJoblevelDialog(true);
                  } else {
                    setEmployeeFormData({ ...employeeFormData, id_job_level: newValue?._id || '' });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter(option => option.joblevel_name?.toLowerCase().includes(params.inputValue.toLowerCase()));
                  if (params.inputValue !== '' && filtered.length === 0) {
                    filtered.push({ isAddNew: true, joblevel_name: `+ Tambah "${params.inputValue}"`, _id: 'add-new' });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Level Pekerjaan" placeholder="Cari level" />
                )}
              />
              <IconButton color="primary" onClick={() => setOpenAddJoblevelDialog(true)} size="large">
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Autocomplete
                fullWidth
                options={businessUnits}
                getOptionLabel={(option) => option?.bu_name || ''}
                value={businessUnits.find(b => b._id === employeeFormData.id_bu) || null}
                onChange={(_, newValue) => {
                  if (newValue?.isAddNew) {
                    setOpenAddBuDialog(true);
                  } else {
                    setEmployeeFormData({ ...employeeFormData, id_bu: newValue?._id || '' });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter(option => option.bu_name?.toLowerCase().includes(params.inputValue.toLowerCase()));
                  if (params.inputValue !== '' && filtered.length === 0) {
                    filtered.push({ isAddNew: true, bu_name: `+ Tambah "${params.inputValue}"`, _id: 'add-new' });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Unit Bisnis" placeholder="Cari unit bisnis" />
                )}
              />
              <IconButton color="primary" onClick={() => setOpenAddBuDialog(true)} size="large">
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Autocomplete
                fullWidth
                options={offices}
                getOptionLabel={(option) => option?.office_name || ''}
                value={offices.find(o => o._id === employeeFormData.id_office) || null}
                onChange={(_, newValue) => {
                  if (newValue?.isAddNew) {
                    setOpenAddOfficeDialog(true);
                  } else {
                    setEmployeeFormData({ ...employeeFormData, id_office: newValue?._id || '' });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter(option => option.office_name?.toLowerCase().includes(params.inputValue.toLowerCase()));
                  if (params.inputValue !== '' && filtered.length === 0) {
                    filtered.push({ isAddNew: true, office_name: `+ Tambah "${params.inputValue}"`, _id: 'add-new' });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Kantor" placeholder="Cari kantor" />
                )}
              />
              <IconButton color="primary" onClick={() => setOpenAddOfficeDialog(true)} size="large">
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tanggal Bergabung"
              type="date"
              value={employeeFormData.hire_date}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, hire_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {/* Quick-add dialogs (Departemen, Designasi, Joblevel, BU, Office) */}
        <Dialog open={openAddDepartmentDialog} onClose={() => setOpenAddDepartmentDialog(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Tambah Departemen</DialogTitle>
          <DialogContent>
            <TextField margin="dense" label="Kode Departemen" fullWidth value={newDepartmentCode} onChange={(e) => setNewDepartmentCode(e.target.value)} />
            <TextField margin="dense" label="Nama Departemen" fullWidth value={newDepartmentName} onChange={(e) => setNewDepartmentName(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddDepartmentDialog(false)}>Batal</Button>
            <Button onClick={handleQuickAddDepartment} variant="contained">Simpan</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAddDesignationDialog} onClose={() => setOpenAddDesignationDialog(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Tambah Posisi</DialogTitle>
          <DialogContent>
            <TextField margin="dense" label="Kode Posisi" fullWidth value={newDesignationCode} onChange={(e) => setNewDesignationCode(e.target.value)} />
            <TextField margin="dense" label="Nama Posisi" fullWidth value={newDesignationName} onChange={(e) => setNewDesignationName(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddDesignationDialog(false)}>Batal</Button>
            <Button onClick={handleQuickAddDesignation} variant="contained">Simpan</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAddJoblevelDialog} onClose={() => setOpenAddJoblevelDialog(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Tambah Level Pekerjaan</DialogTitle>
          <DialogContent>
            <TextField margin="dense" label="Kode Level" fullWidth value={newJoblevelCode} onChange={(e) => setNewJoblevelCode(e.target.value)} />
            <TextField margin="dense" label="Nama Level" fullWidth value={newJoblevelName} onChange={(e) => setNewJoblevelName(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddJoblevelDialog(false)}>Batal</Button>
            <Button onClick={handleQuickAddJoblevel} variant="contained">Simpan</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAddBuDialog} onClose={() => setOpenAddBuDialog(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Tambah Unit Bisnis</DialogTitle>
          <DialogContent>
            <TextField margin="dense" label="Kode Unit Bisnis" fullWidth value={newBuCode} onChange={(e) => setNewBuCode(e.target.value)} />
            <TextField margin="dense" label="Nama Unit Bisnis" fullWidth value={newBuName} onChange={(e) => setNewBuName(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddBuDialog(false)}>Batal</Button>
            <Button onClick={handleQuickAddBu} variant="contained">Simpan</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAddOfficeDialog} onClose={() => setOpenAddOfficeDialog(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Tambah Kantor</DialogTitle>
          <DialogContent>
            <TextField margin="dense" label="Kode Kantor" fullWidth value={newOfficeCode} onChange={(e) => setNewOfficeCode(e.target.value)} />
            <TextField margin="dense" label="Nama Kantor" fullWidth value={newOfficeName} onChange={(e) => setNewOfficeName(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddOfficeDialog(false)}>Batal</Button>
            <Button onClick={handleQuickAddOffice} variant="contained">Simpan</Button>
          </DialogActions>
        </Dialog>

      </CardContent>
    </Card>
  );

  const renderEducationLocationForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'secondary.main' }}>
            <SchoolIcon />
          </Avatar>
        }
        title="Pendidikan & Lokasi"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Perguruan Tinggi"
              value={employeeFormData.collage}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, collage: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tingkat Pendidikan"
              value={employeeFormData.education}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, education: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Jurusan"
              value={employeeFormData.education_major}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, education_major: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Grade"
              value={employeeFormData.grade}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, grade: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Alamat"
              multiline
              rows={2}
              value={employeeFormData.address}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, address: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="ID Kecamatan"
              value={employeeFormData.id_subdistrict}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, id_subdistrict: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="ID Kota"
              value={employeeFormData.id_city}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, id_city: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="ID Provinsi"
              value={employeeFormData.id_province}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, id_province: e.target.value })}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderAdditionalInfoForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'warning.main' }}>
            <LocationIcon />
          </Avatar>
        }
        title="Informasi Tambahan"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="BPJS TK"
              value={employeeFormData.bpjs_tk}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, bpjs_tk: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="BPJS Kesehatan"
              value={employeeFormData.bpjs_kes}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, bpjs_kes: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kategori Pajak"
              value={employeeFormData.tax_category}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, tax_category: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="PPh21"
              value={employeeFormData.pph21}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, pph21: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tanggal Lahir"
              type="date"
              value={employeeFormData.birth_date}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, birth_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tanggal Ditambahkan"
              type="date"
              value={employeeFormData.date_added}
              onChange={(e) => setEmployeeFormData({ ...employeeFormData, date_added: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
          </CardContent>
        </Card>
  );

  const renderCandidateHistoryForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'success.main' }}>
            <WorkIcon />
              </Avatar>
            }
        title="Data Kandidat - Riwayat"
            titleTypographyProps={{ fontWeight: 600 }}
          />
      <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Tempat Lahir"
              value={employeeFormData.staticData.personalData.birth_place}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                        birth_place: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Agama"
              value={employeeFormData.staticData.personalData.religion}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                        religion: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Suku"
              value={employeeFormData.staticData.personalData.ethnicity}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                        ethnicity: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
              label="Usia"
              type="number"
              value={employeeFormData.staticData.personalData.age}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                    age: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Tinggi (cm)"
                  type="number"
              value={employeeFormData.staticData.personalData.height_cm}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                        height_cm: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Berat (kg)"
                  type="number"
              value={employeeFormData.staticData.personalData.weight_kg}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      personalData: {
                        ...employeeFormData.staticData.personalData,
                        weight_kg: e.target.value
                      }
                    }
                  })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Alasan Keluar Kerja Terakhir"
              value={employeeFormData.staticData.history.last_job_reason_leave}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  history: {
                    ...employeeFormData.staticData.history,
                    last_job_reason_leave: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Gaji Terakhir"
              value={employeeFormData.staticData.history.last_job_salary}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  history: {
                    ...employeeFormData.staticData.history,
                    last_job_salary: e.target.value
                  }
                }
              })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Hobi"
              value={employeeFormData.staticData.history.hobby}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      history: {
                        ...employeeFormData.staticData.history,
                        hobby: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Olahraga"
              value={employeeFormData.staticData.history.sport}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                      history: {
                        ...employeeFormData.staticData.history,
                        sport: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderCandidateFamilyForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'warning.main' }}>
            <PersonIcon />
          </Avatar>
        }
        title="Data Kandidat - Keluarga"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
              label="Status Pernikahan"
              value={employeeFormData.staticData.personalData.marital_status}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    marital_status: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
              label="Tanggal Menikah"
              type="date"
              value={employeeFormData.staticData.personalData.marital_date}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    marital_date: e.target.value
                      }
                    }
                  })}
              InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
              label="Nama Gadis Ibu"
              value={employeeFormData.staticData.personalData.mother_maiden_name}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    mother_maiden_name: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
              label="Status Tinggal"
              value={employeeFormData.staticData.personalData.living_status}
                  onChange={(e) => setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    living_status: e.target.value
                      }
                    }
                  })}
                />
              </Grid>
          
          {/* Data Keluarga Multiple */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Data Keluarga
              </Typography>
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={addFamilyMember}
                startIcon={<AddIcon />}
                sx={{ borderRadius: 2 }}
              >
                Tambah Keluarga
              </Button>
            </Box>
            
            {employeeFormData.staticData.family.map((member, index) => (
              <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Jenis Keluarga</InputLabel>
                      <Select
                        value={member.type}
                        onChange={(e) => updateFamilyMember(index, 'type', e.target.value)}
                      >
                        <MenuItem value="Spouse">Suami/Istri</MenuItem>
                        <MenuItem value="Child">Anak</MenuItem>
                        <MenuItem value="Parent">Orang Tua</MenuItem>
                        <MenuItem value="Sibling">Saudara</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Nama"
                      value={member.name}
                      onChange={(e) => updateFamilyMember(index, 'name', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>L/P</InputLabel>
                      <Select
                        value={member.gender}
                        onChange={(e) => updateFamilyMember(index, 'gender', e.target.value)}
                      >
                        <MenuItem value="L">Laki-laki</MenuItem>
                        <MenuItem value="P">Perempuan</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Usia"
                      type="number"
                      value={member.age}
                      onChange={(e) => updateFamilyMember(index, 'age', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <IconButton
                      color="error"
                      onClick={() => removeFamilyMember(index)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Pendidikan"
                      value={member.education}
                      onChange={(e) => updateFamilyMember(index, 'education', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Pekerjaan"
                      value={member.job}
                      onChange={(e) => updateFamilyMember(index, 'job', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Perusahaan"
                      value={member.company}
                      onChange={(e) => updateFamilyMember(index, 'company', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Keterangan"
                      value={member.notes}
                      onChange={(e) => updateFamilyMember(index, 'notes', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Grid>
        </Grid>
          </CardContent>
        </Card>
  );

  const renderCandidateSkillsForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'secondary.main' }}>
            <WorkIcon />
          </Avatar>
        }
        title="Data Kandidat - Kemampuan"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Alasan Melamar"
              multiline
              rows={2}
              value={employeeFormData.staticData.applicationSkills.apply_reason}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    apply_reason: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Posisi yang Diinginkan"
              value={employeeFormData.staticData.applicationSkills.desired_position}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    desired_position: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Gaji yang Diharapkan"
              value={employeeFormData.staticData.applicationSkills.expected_salary}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    expected_salary: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Keahlian"
              value={employeeFormData.staticData.applicationSkills.skills}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    skills: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Program Komputer"
              value={employeeFormData.staticData.applicationSkills.computer_programs}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    computer_programs: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kemampuan Mengemudi"
              value={employeeFormData.staticData.applicationSkills.driving_ability}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  applicationSkills: {
                    ...employeeFormData.staticData.applicationSkills,
                    driving_ability: e.target.value
                  }
                }
              })}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderCandidateHealthForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'error.main' }}>
            <PersonIcon />
          </Avatar>
        }
        title="Data Kandidat - Kesehatan"
        titleTypographyProps={{ fontWeight: 600 }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Penyakit Umum"
              value={employeeFormData.staticData.generalHealth.common_illness}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  generalHealth: {
                    ...employeeFormData.staticData.generalHealth,
                    common_illness: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Pemeriksaan Terakhir"
              type="date"
              value={employeeFormData.staticData.generalHealth.last_checkup}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  generalHealth: {
                    ...employeeFormData.staticData.generalHealth,
                    last_checkup: e.target.value
                  }
                }
              })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kekuatan"
              multiline
              rows={2}
              value={employeeFormData.staticData.generalHealth.strength}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  generalHealth: {
                    ...employeeFormData.staticData.generalHealth,
                    strength: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Kelemahan"
              multiline
              rows={2}
              value={employeeFormData.staticData.generalHealth.weakness}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  generalHealth: {
                    ...employeeFormData.staticData.generalHealth,
                    weakness: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Reaksi terhadap Kritik"
              value={employeeFormData.staticData.generalHealth.reaction_to_criticism}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  generalHealth: {
                    ...employeeFormData.staticData.generalHealth,
                    reaction_to_criticism: e.target.value
                  }
                }
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Prestasi Terbaik"
              value={employeeFormData.staticData.personalData.best_achievement}
              onChange={(e) => setEmployeeFormData({
                ...employeeFormData,
                staticData: {
                  ...employeeFormData.staticData,
                  personalData: {
                    ...employeeFormData.staticData.personalData,
                    best_achievement: e.target.value
                  }
                }
              })}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Render Education Form
  const renderEducationForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'info.main' }}>
                <SchoolIcon />
              </Avatar>
            }
            title="Pendidikan Formal"
            titleTypographyProps={{ fontWeight: 600 }}
          />
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Riwayat Pendidikan
              </Typography>
              <Button
                variant="contained"
                color="info"
                size="small"
                onClick={addEducation}
                startIcon={<AddIcon />}
                sx={{ borderRadius: 2 }}
              >
                Tambah Pendidikan
              </Button>
            </Box>
            
        {employeeFormData.staticData.education.map((edu, index) => (
              <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Jenjang</InputLabel>
                      <Select
                    value={edu.level}
                        onChange={(e) => updateEducation(index, 'level', e.target.value)}
                      >
                        <MenuItem value="SD">SD</MenuItem>
                        <MenuItem value="SMP">SMP</MenuItem>
                        <MenuItem value="SMA">SMA/SMK</MenuItem>
                        <MenuItem value="D3">D3</MenuItem>
                        <MenuItem value="S1">S1</MenuItem>
                        <MenuItem value="S2">S2</MenuItem>
                        <MenuItem value="S3">S3</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Nama Sekolah"
                  value={edu.school_name}
                      onChange={(e) => updateEducation(index, 'school_name', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Lokasi"
                  value={edu.location}
                      onChange={(e) => updateEducation(index, 'location', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Tahun Lulus"
                      type="number"
                  value={edu.graduation_year}
                      onChange={(e) => updateEducation(index, 'graduation_year', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <IconButton
                      color="error"
                      onClick={() => removeEducation(index)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="IPK/Nilai"
                  value={edu.gpa}
                      onChange={(e) => updateEducation(index, 'gpa', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Jurusan"
                  value={edu.major}
                      onChange={(e) => updateEducation(index, 'major', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
          </CardContent>
        </Card>
  );

  // Render Work History Form
  const renderWorkHistoryForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'success.main' }}>
                <WorkIcon />
              </Avatar>
            }
            title="Riwayat Pekerjaan"
            titleTypographyProps={{ fontWeight: 600 }}
          />
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Pengalaman Kerja
              </Typography>
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={addWorkHistory}
                startIcon={<AddIcon />}
                sx={{ borderRadius: 2 }}
              >
                Tambah Pekerjaan
              </Button>
            </Box>
            
        {employeeFormData.staticData.workHistory.map((work, index) => (
              <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Tanggal Masuk"
                      type="date"
                  value={work.entry_date}
                      onChange={(e) => updateWorkHistory(index, 'entry_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Tanggal Keluar"
                      type="date"
                  value={work.exit_date}
                      onChange={(e) => updateWorkHistory(index, 'exit_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Jabatan"
                  value={work.position}
                      onChange={(e) => updateWorkHistory(index, 'position', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <IconButton
                      color="error"
                      onClick={() => removeWorkHistory(index)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Perusahaan"
                  value={work.company}
                      onChange={(e) => updateWorkHistory(index, 'company', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Alamat & Telepon"
                  value={work.address_phone}
                      onChange={(e) => updateWorkHistory(index, 'address_phone', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Keterangan"
                  value={work.notes}
                      onChange={(e) => updateWorkHistory(index, 'notes', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
          </CardContent>
        </Card>
  );

  // Render Courses Form
  const renderCoursesForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'warning.main' }}>
                <SchoolIcon />
              </Avatar>
            }
            title="Kursus & Pelatihan"
            titleTypographyProps={{ fontWeight: 600 }}
          />
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Riwayat Kursus
              </Typography>
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={addCourse}
                startIcon={<AddIcon />}
                sx={{ borderRadius: 2 }}
              >
                Tambah Kursus
              </Button>
            </Box>
            
        {employeeFormData.staticData.courses.map((course, index) => (
              <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Instruktur/Lembaga"
                  value={course.instructor_institution}
                      onChange={(e) => updateCourse(index, 'instructor_institution', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Lokasi"
                  value={course.location}
                      onChange={(e) => updateCourse(index, 'location', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Durasi"
                  value={course.duration}
                      onChange={(e) => updateCourse(index, 'duration', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Dibiayai"
                  value={course.funded_by}
                      onChange={(e) => updateCourse(index, 'funded_by', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Keterangan"
                  value={course.notes}
                      onChange={(e) => updateCourse(index, 'notes', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <IconButton
                      color="error"
                      onClick={() => removeCourse(index)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </CardContent>
        </Card>
  );

  // Render Relations Form
  const renderRelationsForm = () => (
    <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: 'error.main' }}>
                <ContactsIcon />
              </Avatar>
            }
            title="Relasi & Penjamin"
            titleTypographyProps={{ fontWeight: 600 }}
          />
          <CardContent>
            {/* Emergency Relations */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Relasi Darurat
                </Typography>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={addEmergencyRelation}
                  startIcon={<AddIcon />}
                  sx={{ borderRadius: 2 }}
                >
                  Tambah Kontak Darurat
                </Button>
              </Box>
              
          {employeeFormData.staticData.emergency_relations.map((relation, index) => (
                <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nama"
                    value={relation.name}
                        onChange={(e) => updateEmergencyRelation(index, 'name', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Usia"
                        type="number"
                    value={relation.age}
                        onChange={(e) => updateEmergencyRelation(index, 'age', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Alamat"
                    value={relation.address}
                        onChange={(e) => updateEmergencyRelation(index, 'address', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Telepon"
                    value={relation.phone}
                        onChange={(e) => updateEmergencyRelation(index, 'phone', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <IconButton
                        color="error"
                        onClick={() => removeEmergencyRelation(index)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Hubungan"
                    value={relation.relationship}
                        onChange={(e) => updateEmergencyRelation(index, 'relationship', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Keterangan"
                    value={relation.notes}
                        onChange={(e) => updateEmergencyRelation(index, 'notes', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Card>
              ))}
            </Box>

            {/* Former Relations */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Eks Atasan/Keluarga
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={addFormerRelation}
                  startIcon={<AddIcon />}
                  sx={{ borderRadius: 2 }}
                >
                  Tambah Referensi
                </Button>
              </Box>
              
          {employeeFormData.staticData.former_relations.map((relation, index) => (
                <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nama"
                    value={relation.name}
                        onChange={(e) => updateFormerRelation(index, 'name', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Usia"
                        type="number"
                    value={relation.age}
                        onChange={(e) => updateFormerRelation(index, 'age', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Alamat"
                    value={relation.address}
                        onChange={(e) => updateFormerRelation(index, 'address', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Telepon"
                    value={relation.phone}
                        onChange={(e) => updateFormerRelation(index, 'phone', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <IconButton
                        color="error"
                        onClick={() => removeFormerRelation(index)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Hubungan"
                    value={relation.relationship}
                        onChange={(e) => updateFormerRelation(index, 'relationship', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Keterangan"
                    value={relation.notes}
                        onChange={(e) => updateFormerRelation(index, 'notes', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Card>
              ))}
            </Box>

            {/* Guarantors */}
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Penjamin
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={addGuarantor}
                  startIcon={<AddIcon />}
                  sx={{ borderRadius: 2 }}
                >
                  Tambah Penjamin
                </Button>
              </Box>
              
          {employeeFormData.staticData.guarantors.map((guarantor, index) => (
                <Card key={index} sx={{ mb: 2, p: 2, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nama"
                    value={guarantor.name}
                        onChange={(e) => updateGuarantor(index, 'name', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Usia"
                        type="number"
                    value={guarantor.age}
                        onChange={(e) => updateGuarantor(index, 'age', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Alamat"
                    value={guarantor.address}
                        onChange={(e) => updateGuarantor(index, 'address', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Telepon"
                    value={guarantor.phone}
                        onChange={(e) => updateGuarantor(index, 'phone', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <IconButton
                        color="error"
                        onClick={() => removeGuarantor(index)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Hubungan"
                    value={guarantor.relationship}
                        onChange={(e) => updateGuarantor(index, 'relationship', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Keterangan"
                    value={guarantor.notes}
                        onChange={(e) => updateGuarantor(index, 'notes', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Card>
              ))}
            </Box>
          </CardContent>
        </Card>
  );

  // Helper functions for managing arrays
  const addFamilyMember = () => {
    const newMember = {
      type: '',
      name: '',
      gender: '',
      age: '',
      education: '',
      position: '',
      job: '',
      company: '',
      notes: ''
    };
    setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
        family: [...employeeFormData.staticData.family, newMember]
      }
    });
  };

  const removeFamilyMember = (index) => {
    const updatedFamily = employeeFormData.staticData.family.filter((_, i) => i !== index);
    setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
        family: updatedFamily
      }
    });
  };

  const updateFamilyMember = (index, field, value) => {
    const updatedFamily = employeeFormData.staticData.family.map((member, i) => 
      i === index ? { ...member, [field]: value } : member
    );
    setEmployeeFormData({
                    ...employeeFormData,
                    staticData: {
                      ...employeeFormData.staticData,
        family: updatedFamily
      }
    });
  };

  // Functions for Education Management
  const addEducation = () => {
    const newEducation = {
      level: '',
      school_name: '',
      location: '',
      graduation_year: '',
      gpa: '',
      major: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        education: [...employeeFormData.staticData.education, newEducation]
      }
    });
  };

  const removeEducation = (index) => {
    const updatedEducation = employeeFormData.staticData.education.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        education: updatedEducation
      }
    });
  };

  const updateEducation = (index, field, value) => {
    const updatedEducation = employeeFormData.staticData.education.map((edu, i) => 
      i === index ? { ...edu, [field]: value } : edu
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        education: updatedEducation
      }
    });
  };

  // Functions for Work History Management
  const addWorkHistory = () => {
    const newWork = {
      entry_date: '',
      exit_date: '',
      position: '',
      company: '',
      address_phone: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        workHistory: [...employeeFormData.staticData.workHistory, newWork]
      }
    });
  };

  const removeWorkHistory = (index) => {
    const updatedWorkHistory = employeeFormData.staticData.workHistory.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        workHistory: updatedWorkHistory
      }
    });
  };

  const updateWorkHistory = (index, field, value) => {
    const updatedWorkHistory = employeeFormData.staticData.workHistory.map((work, i) => 
      i === index ? { ...work, [field]: value } : work
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        workHistory: updatedWorkHistory
      }
    });
  };

  // Functions for Courses Management
  const addCourse = () => {
    const newCourse = {
      instructor_institution: '',
      location: '',
      duration: '',
      funded_by: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        courses: [...employeeFormData.staticData.courses, newCourse]
      }
    });
  };

  const removeCourse = (index) => {
    const updatedCourses = employeeFormData.staticData.courses.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        courses: updatedCourses
      }
    });
  };

  const updateCourse = (index, field, value) => {
    const updatedCourses = employeeFormData.staticData.courses.map((course, i) => 
      i === index ? { ...course, [field]: value } : course
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        courses: updatedCourses
      }
    });
  };

  // Functions for Social Activities Management
  const addSocialActivity = () => {
    const newActivity = {
      year: '',
      activity_type: '',
      position: '',
      organization: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        socialActivities: [...employeeFormData.staticData.socialActivities, newActivity]
      }
    });
  };

  const removeSocialActivity = (index) => {
    const updatedActivities = employeeFormData.staticData.socialActivities.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        socialActivities: updatedActivities
      }
    });
  };

  const updateSocialActivity = (index, field, value) => {
    const updatedActivities = employeeFormData.staticData.socialActivities.map((activity, i) => 
      i === index ? { ...activity, [field]: value } : activity
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        socialActivities: updatedActivities
      }
    });
  };

  // Functions for Emergency Relations Management
  const addEmergencyRelation = () => {
    const newRelation = {
      name: '',
      age: '',
      address: '',
      phone: '',
      relationship: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        emergency_relations: [...employeeFormData.staticData.emergency_relations, newRelation]
      }
    });
  };

  const removeEmergencyRelation = (index) => {
    const updatedRelations = employeeFormData.staticData.emergency_relations.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        emergency_relations: updatedRelations
      }
    });
  };

  const updateEmergencyRelation = (index, field, value) => {
    const updatedRelations = employeeFormData.staticData.emergency_relations.map((relation, i) => 
      i === index ? { ...relation, [field]: value } : relation
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        emergency_relations: updatedRelations
      }
    });
  };

  // Functions for Former Relations Management
  const addFormerRelation = () => {
    const newRelation = {
      name: '',
      age: '',
      address: '',
      phone: '',
      relationship: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        former_relations: [...employeeFormData.staticData.former_relations, newRelation]
      }
    });
  };

  const removeFormerRelation = (index) => {
    const updatedRelations = employeeFormData.staticData.former_relations.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        former_relations: updatedRelations
      }
    });
  };

  const updateFormerRelation = (index, field, value) => {
    const updatedRelations = employeeFormData.staticData.former_relations.map((relation, i) => 
      i === index ? { ...relation, [field]: value } : relation
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        former_relations: updatedRelations
      }
    });
  };

  // Functions for Guarantors Management
  const addGuarantor = () => {
    const newGuarantor = {
      name: '',
      age: '',
      address: '',
      phone: '',
      relationship: '',
      notes: ''
    };
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        guarantors: [...employeeFormData.staticData.guarantors, newGuarantor]
      }
    });
  };

  const removeGuarantor = (index) => {
    const updatedGuarantors = employeeFormData.staticData.guarantors.filter((_, i) => i !== index);
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        guarantors: updatedGuarantors
      }
    });
  };

  const updateGuarantor = (index, field, value) => {
    const updatedGuarantors = employeeFormData.staticData.guarantors.map((guarantor, i) => 
      i === index ? { ...guarantor, [field]: value } : guarantor
    );
    setEmployeeFormData({
      ...employeeFormData,
      staticData: {
        ...employeeFormData.staticData,
        guarantors: updatedGuarantors
      }
    });
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return renderPersonalDataForm();
      case 1:
        return renderWorkInformationForm();
      case 2:
        return renderEducationLocationForm();
      case 3:
        return renderAdditionalInfoForm();
      case 4:
        return renderCandidateHistoryForm();
      case 5:
        return renderCandidateFamilyForm();
      case 6:
        return renderCandidateSkillsForm();
      case 7:
        return renderCandidateHealthForm();
      case 8:
        return renderEducationForm();
      case 9:
        return renderWorkHistoryForm();
      case 10:
        return renderCoursesForm();
      case 11:
        return renderRelationsForm();
      default:
        return null;
    }
  };
  
  if (fetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Memuat data karyawan...
              </Typography>
            </Box>
    );
  }
  
  return (
    <Box sx={{ p: 2 }} className="animate-fade-in">
        {/* Header */}
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
            onClick={() => navigate('/kontak/employee')}
            sx={{ 
              bgcolor: 'grey.100',
              '&:hover': { bgcolor: 'grey.200' }
            }}
          >
            <ArrowBackIcon />
                    </IconButton>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            Edit Karyawan
              </Typography>
            </Box>
            
        {/* Stepper */}
        <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>

        {/* Form Content */}
        <Box sx={{ mb: 3 }}>
          {renderStepContent(activeStep)}
              </Box>
              
        {/* Navigation Buttons */}
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button 
              disabled={activeStep === 0}
              onClick={handleBack}
              variant="outlined" 
              size="large"
            >
              Kembali
                </Button>
            <Box sx={{ display: 'flex', gap: 2 }}>
              {activeStep === steps.length - 1 ? (
                <Button
                  variant="contained"
                  onClick={handleSaveEmployee}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                  disabled={loading}
              size="large"
              sx={{ 
                px: 4,
                py: 1.5,
                fontWeight: 600
              }}
            >
                  {loading ? 'Mengupdate...' : 'Update Karyawan'}
            </Button>
              ) : (
            <Button 
              variant="contained" 
                  onClick={handleNext}
              size="large"
              sx={{ 
                px: 4,
                py: 1.5,
                fontWeight: 600
              }}
            >
                  Selanjutnya
            </Button>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>
  );
};

export default EditEmployee;